import type { ModelConfig } from '@modelstack/shared-schema/auth'

export interface UserTierPreferencesItem {
  userId: string
  modelConfig: ModelConfig
}

interface ApiResponse {
  success: boolean
  data?: UserTierPreferencesItem
}

export const userTierPreferencesService = {
  async get(): Promise<UserTierPreferencesItem> {
    const response = await fetch('/api/user-tier-preferences', {
      credentials: 'include',
      cache: 'no-store',
    })
    if (!response.ok) {
      throw new Error('Failed to fetch user tier preferences')
    }
    const result: ApiResponse = await response.json()
    if (!result.data) {
      throw new Error('No data returned')
    }
    return result.data
  },

  async update(modelConfig: ModelConfig): Promise<{ success: boolean }> {
    const response = await fetch('/api/user-tier-preferences', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      cache: 'no-store',
      body: JSON.stringify({ modelConfig }),
    })
    if (!response.ok) {
      const error = (await response.json().catch(() => ({}))) as {
        error?: string
      }
      throw new Error(error.error || 'Failed to update user tier preferences')
    }
    return await response.json()
  },
}
